// @flow
import React, { Component } from 'react'
import { translations, translateFunc } from '../../../shared/localize'
import { RetargetingNote, Text } from './elements'

const t = translateFunc(translations.audience_edit.price_recommendations.retargeting_wrapper)

type Props = {|
  children: any
|}

export default class RetargetingWrapper extends Component<Props> {
  render() {
    return (
      <div>
        {this.props.children}
        <RetargetingNote>
          <Text>{t('retargeting_description')}</Text>
          <Text>
            <a target="_blank" href="/help/#budget">
              {t('best_budget_for_retargeting')}
            </a>{' '}
            {t('in_help_center')}
          </Text>
        </RetargetingNote>
      </div>
    )
  }
}
